import router from './router'
import store from '@/store'

import {getToken} from '@/utils/cookie'
import {corpInterceptor, memberInterceptor} from '@/router/corporation'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({showSpinner: false}) // NProgress Configuration

// 白名单请求
let whiteList = ['/wx_login/author']

/**
 * 验证白名单
 */
const verifyWhiteList = path => {
  return whiteList.indexOf(path) > -1
}

/**
 * 全局前置守卫
 */
router.beforeEach((to, from, next) => {
  NProgress.start() //  start progress bar

  // 过滤白名单路由
  if (verifyWhiteList(to.path)) {
    next()
  } else {
    getToken() ? handleHasToken(to, next) : handleNoToken(to, next)
  }

  NProgress.done() // finish progress bar
})

/**
 * 全局后置钩子
 */
router.afterEach((to, from) => {
  NProgress.done() // finish progress bar

  // 浏览器标题
  // setTimeout(() => {
  //     const windowTitle = store.getters.windowTitle
  //     console.info(windowTitle)
  //     window.document.title = windowTitle
  // }, 0)
})

/**
 * 有token时
 */
let handleHasToken = (to, next) => {
  if (store.state.login.loginType === 'member') {
    memberInterceptor(to, next)
  } else {
    // 登录成功后选择企业
    if (to.path === '/login' || store.state.login.loginActive === 2) {
      next()
    } else {
      corpInterceptor(to, next)
    }
  }
}

/**
 * 没有token时
 */
let handleNoToken = (to, next) => {
  if (to.path === '/login' || to.path === '/login/member' || to.path === '/register') {
    next()
  } else {
    next(store.state.login.loginType === 'member' ? '/login/member' : '/login')
  }
}



// WEBPACK FOOTER //
// ./src/permission.js